/**
 * Tr.jsx
 *
 * @Author: apple
 * @Date: 2018/4/17 18:09
 */

import React from 'react';
import classNames from 'classnames';
import TableCell from './TableCell';
import ChevronRight from '../icons/internals/ChevronRight';
import ExpandMore from '../icons/internals/ExpandMore';
import { isFunction } from '../util/isType';
import pubsub from '../util/observer';
import { addClass, deleteClass } from '../util/operateClass';

class Tr extends React.PureComponent {
  static propTypes = {};

  static defaultProps = {};

  constructor(props, context) {
    super(props, context);
    const { id, pubsubEventString } = this.props;
    // 事件随机key值，确保在整个项目中独一无二
    this.pubsubEvent = {
      expandRow: `${id}-${pubsubEventString.token}-expand-main`,
      shrinkRow: `${id}-${pubsubEventString.token}-shrink-main`,
      fixExpandRow: `${id}-${pubsubEventString.token}-expand-fix`,
      fixShrinkRow: `${id}-${pubsubEventString.token}-shrink-fix`,
      mouseEnterRow: `${id}-${pubsubEventString.token}-mouseEnterRow`,
      mouseLeaveRow: `${id}-${pubsubEventString.token}-mouseLeaveRow`,
    };
    this.state = {
      displayExpandRow: false,
      displayExpandSonRow: false
    };
  }

  componentDidMount() {
    const self = this;
    const { position } = this.props;
    const {
      expandRow,
      shrinkRow,
      fixExpandRow,
      fixShrinkRow,
      mouseEnterRow,
      mouseLeaveRow,
    } = this.pubsubEvent;
    // 需要针对是否是主表格来决定如何监听
    if (position === 'main') {
      // 订阅打开展开栏事件
      pubsub.subscribe(expandRow, () => {
        self.setState(
          {
            displayExpandRow: true,
            arrowType: 'down-arrow',
          },
          () => {
            // pubsub.publish(fixExpandRow, this.expandTr.getBoundingClientRect().height);
          },
        );
      });
      // 订阅收缩展开栏事件
      pubsub.subscribe(shrinkRow, () => {
        self.setState(
          {
            displayExpandRow: false,
            arrowType: 'right-arrow',
          },
          () => {
            pubsub.publish(fixShrinkRow);
          },
        );
      });
    } else {
      // 订阅固定列打开展开栏事件
      pubsub.subscribe(fixExpandRow, (event, height) => {
        self.setState({
          displayExpandRow: true,
          arrowType: 'down-arrow',
        });
        this.expandTr.style.height = `${height}px`;
      });
      // 订阅固定列收缩展开栏事件
      pubsub.subscribe(fixShrinkRow, () => {
        self.setState({
          displayExpandRow: false,
          arrowType: 'right-arrow',
        });
      });
    }
    pubsub.subscribe(mouseEnterRow, () => {
      addClass(this.normalTr, 'ne-table-is-hover');
    });
    pubsub.subscribe(mouseLeaveRow, () => {
      deleteClass(this.normalTr, 'ne-table-is-hover');
    });
  }

  componentWillUnmount() {
    for (const item in this.pubsubEvent) {
      pubsub.unsubscribe(item);
    }
  }

  handleExpandClick = (e, type) => {
    const { expandRow, shrinkRow } = this.pubsubEvent;
    const { position } = this.props;
    if (position === 'left' || position === 'main') {
      if (type === 'right-arrow') {
        pubsub.publish(expandRow);
      }
      if (type === 'down-arrow') {
        pubsub.publish(shrinkRow);
      }
    }
  };

  handleExpandRowClick = (e, type, id, pid) => {
    const { position } = this.props;
    if (position === 'left' || position === 'main') {
      if (type === 'right-arrow') {
        this.setState({
          arrowType: 'down-arrow',
          displayExpandSonRow: true,
        });
      }
      if (type === 'down-arrow') {
        this.setState({
          arrowType: 'right-arrow',
          displayExpandSonRow: false,
        });
      }
    }
    this.props.handleExpandRowClick(type, id, pid);
  };

  handleMouseEnter = () => {
    const { hover } = this.props;
    const { mouseEnterRow } = this.pubsubEvent;
    hover && pubsub.publish(mouseEnterRow);
  };

  handleMouseLeave = () => {
    const { hover } = this.props;
    const { mouseLeaveRow } = this.pubsubEvent;
    hover && pubsub.publish(mouseLeaveRow);
  };

  render() {
    const mine = this;
    const {
      id,
      level,
      elm,
      classStr,
      renderColumns,
      data,
      rules,
      colSpan,
      selfPrefixCls,
      position,
      dis,
      expandOpt,
      children,
      pid,
    } = this.props;
    const { displayExpandRow, displayExpandSonRow } = this.state;
    const { expandRow, shrinkRow } = this.pubsubEvent;
    const displayStyle = {};
    if (dis) {
      displayStyle.display = 'none';
    }
    const trClass = classStr;
    let flag = false;
    let indexFlag = 0;
    return [
      <tr
        key={`tr-${id}`}
        data-row={id}
        className={trClass}
        style={displayStyle}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        ref={normalTr => (this.normalTr = normalTr)}>
        {isFunction(elm)
          ? elm(rules.length)
          : rules.map((e, index) => {
              if (e !== 'checkbox' && e !== 'expandBtn'){flag = true;indexFlag += 1;}
              let render = renderColumns[index].render;
              if (e === 'expandBtn' && expandOpt) {
                let type = 'right-arrow';
                if (displayExpandRow) {
                  type = 'down-arrow';
                }
                const Component = displayExpandRow ? ExpandMore : ChevronRight;
                render = () => <Component onClick={e => mine.handleExpandClick(e, type)} />;
              }
              if (e === 'expandBtn' && children && elm.children) {
                let type = 'right-arrow';
                if (displayExpandSonRow) {
                  type = 'down-arrow';
                }
                const Component = displayExpandSonRow ? ExpandMore : ChevronRight;
                render = () => <Component onClick={e => mine.handleExpandRowClick(e, type, elm.id, pid)} />;
              }
              let renderData = data;
              if (elm._tableExpandRow) {
                renderData = { ...data };
                delete renderData._tableExpandRow;
              }
              return (
                <TableCell
                  key={`tr-${id}-td-${e}`}
                  content={elm[e]}
                  className={classNames(renderColumns[index].className, {
                    'text-center': renderColumns[index].textCenter,
                  })}
                  level={(flag && indexFlag < 2) ? level : ''}
                  render={
                    isFunction(render)
                      ? () =>
                          render(id, renderData, e, {
                            publish: event => pubsub.publish(event),
                            shrinkEvent: shrinkRow,
                            expandEvent: expandRow,
                          })
                      : null
                  }/>
              );
            })}
      </tr>,
      // 展开栏
      elm._tableExpandRow && displayExpandRow && (
        <tr
          key={`tr-${id}-expand`}
          data-row={`${id}-expand`}
          ref={expandTr => (this.expandTr = expandTr)}>
          <TableCell
            colSpan={`${colSpan}`}
            style={displayStyle}
            content={elm._tableExpandRow()}
            className={classNames(`${selfPrefixCls}-body-expand-row-${position}`)}
            key={`tr-${id}-td-expand`}/>
        </tr>
      ),
    ];
  }
}

export default Tr;



// WEBPACK FOOTER //
// ./src/table/Tr.jsx